import React, { useEffect, useState } from "react";
import FormContainer from "./FormContainer";
import ImageUpload from "./ImageComponent";
import profile from "../../assets/images/user.png";
import batminton from "../../assets/images/games/bt.png";
import tabletenis from "../../assets/images/games/tt.png";
import bowling1 from "../../assets/images/games/Bowling11.svg";
import walk from "../../assets/images/games/walk1.svg";

import { json, useFetcher, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import Loader from "../../views/admin/Common/Loader";
import {
  getPlayerSports,
  CurrentTournament,
  updateSport,
  updateUser,
  enrolledUser,
  avalibleSlotsAPI,
  uploadImage,
  enrolledWaiting,
  WaitlistPlayersAPI,
  ExitWaitList,
  playerEnrolledSportsAPI,
  FetchEnrolleMentToken,
  FetchEnrolledHoldSlotData,
} from "../../API/player";
import {
  IsMatchDone,
  getSetting,
  FilterDynamicText,
  CreateUser as CreateUserAPI,
  GetTournamentList,
} from "../../API/admin";
import { GetTeams, Profile, UpdateProfile } from "../../API/auth";

import Swal from "sweetalert2";
import { findAllByDisplayValue } from "@testing-library/react";
const SportSelection = () => {
  // let showsport =JSON.parse( localStorage.getItem('showsport'));
  let navigate = useNavigate();
  const [loaderStatus, setloaderStatus] = useState(false);
  const [badmintionSlot, setBadmintionSlot] = useState(null);
  const [tableTennisSlot, setTableTenniSlot] = useState(null);
  const [bowlingSlot, setBowlingSlot] = useState(null);
  const [twokRunSlot, settwokRuniSlot] = useState(null);
  const [waitListActive, setWaitListActive] = useState({
    ["badminton"]: { waitList: false, sport: null, round: null },
    ["table_tenis"]: { waitList: false, sport: null, round: null },
    ["bowling"]: { waitList: false, sport: null, round: null },
    ["twok_run"]: { waitList: false, sport: null, round: null },
  });
  const [logout, setLogout] = useState(false);
  const [logoutCount, setLogoutCount] = useState(0);
  const [DashboardRedirect, setDashboardRedirect] = useState(false);

  const [EnableSubmit, setEnableSubmit] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [FormData, setFormData] = useState({
    sports: [],
    image: null,
  });
  const [tournament, setTournament] = useState("");
  const [selectBatminton, SetSelectBatminton] = useState(null);
  const [selectTableTenis, SetSelectTableTenis] = useState(null);
  const [selectBowling, SetSelectBowling] = useState(null);
  const [select2k_run, SetSelect2k_run] = useState(null);
  const [sportSelection, setSportSelection] = useState({
    batminton: false,
    tableTenis: false,
    bowling: false,
    twokRun: false,
  });
  const [dynamicHeading, setDynamicHeading] = useState({});
  const [profile, setProfile] = useState(null);
  const [enrolled, setEnrolled] = useState({
    badminton: false,
    table_tennis: false,
    bowling: false,
    twok_run: false,
  });
  const [teams, setTeams] = useState([]);
  const [SelectedTeam, setSelectedTeam] = useState(null);
  const [enrolledTeam, setenrolledTeam] = useState(false);
  const [waitListTeam, setwaitListTeam] = useState(false);
  const [enrollToken, setEnrollToken] = useState(null);

  var showsport = null;

  useEffect(() => {
    let sessionRunning = async () => {
      let res = await FetchEnrolledHoldSlotData();
      if (
        res.status &&
        res.data.occupied_by.toString() === profile.id.toString()
      ) {
        Swal.fire({
          title: "Payment Session in Progress",
          text: "You have an active payment session in progress to book your slot. Please complete or cancel the current session before starting a new one.",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(async (result) => {
          if (result.isConfirmed) {
            var queryParams = "";
            queryParams = new URLSearchParams({
              badminton: res.data.sports.includes("badminton") ? true : false,
              tennis: res.data.sports.includes("table_tenis") ? true : false,
              bowling: res.data.sports.includes("bowling") ? true : false,
              twok_run: res.data.sports.includes("twok_run") ? true : false,
              enroll_token: res.data.token,
            }).toString();
            navigate(`/game-plan?${queryParams}`);
          }
        });
      } else {
        //get the latest token
        let res = await FetchEnrolleMentToken();
        if (res.status) {
          setEnrollToken(res.token);
        }
      }
    };
    const getTeamsAPI = async () => {
      try {
        let res = await GetTeams(profile.city);
        setTeams(res.data);
        if (profile.corporate_email === "") {
          setSelectedTeam(res.data[0].domain);
        }
      } catch (error) {
        console.error("Error fetching teams:", error);
      }
    };

    let avalibleSlots = async () => {
      setloaderStatus(true);

      let formData = {
        team:
          profile.corporate_email === ""
            ? SelectedTeam
            : profile.corporate_email,
        gender: true,
      };
      let res = await avalibleSlotsAPI(formData);
      if (res.status) {
        setloaderStatus(false);
        if (res.data.TotalResult.badminton > 0) {
          SetSelectBatminton({
            title: "Available",
            value: res.data.TotalResult.badminton,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBadmintionSlot(res.data.TotalResult.badminton);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.badminton == 0) {
          SetSelectBatminton({
            title: "Unavailable",
            value: res.data.TotalResult.badminton,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBadmintionSlot(res.data.TotalResult.badminton);
          setWaitListActive((prevState) => ({
            ...prevState,
            badminton: {
              waitList: true,
              sport: "badminton",
              round: "group_stage",
            },
          }));
        }
        if (res.data.TotalResult.table_tenis > 0) {
          SetSelectTableTenis({
            title: "Available",
            value: res.data.TotalResult.table_tenis,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setTableTenniSlot(res.data.TotalResult.table_tenis);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.table_tenis == 0) {
          SetSelectTableTenis({
            title: "Unavailable",
            value: res.data.TotalResult.table_tenis,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setTableTenniSlot(res.data.TotalResult.table_tenis);
          setWaitListActive((prevState) => ({
            ...prevState,
            table_tenis: {
              waitList: true,
              sport: "table_tenis",
              round: "group_stage",
            },
          }));
        }

        //bowling
        if (res.data.TotalResult.bowling > 0) {
          SetSelectBowling({
            title: "Available",
            value: res.data.TotalResult.bowling,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBowlingSlot(res.data.TotalResult.bowling);
          setLogoutCount(logoutCount + 1);
        }

        if (res.data.TotalResult.bowling == 0) {
          SetSelectBowling({
            title: "Unavailable",
            value: res.data.TotalResult.bowling,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBowlingSlot(res.data.TotalResult.bowling);
          setWaitListActive((prevState) => ({
            ...prevState,
            bowling: {
              waitList: true,
              sport: "bowling",
              round: "round_1",
            },
          }));
        }

        //2k_run
        if (res.data.TotalResult.twok_run > 0) {
          SetSelect2k_run({
            title: "Available",
            value: res.data.TotalResult.twok_run,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          settwokRuniSlot(res.data.TotalResult.twok_run);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.twok_run == 0) {
          SetSelect2k_run({
            title: "Unavailable",
            value: res.data.TotalResult.twok_run,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          settwokRuniSlot(res.data.TotalResult.twok_run);
          setWaitListActive((prevState) => ({
            ...prevState,
            twok_run: {
              waitList: true,
              sport: "2k_run",
              round: "round_1",
            },
          }));
        }
      }
    };

    if (profile != null) {
      getTeamsAPI();
      sessionRunning();
      if (profile.corporate_email !== "") {
        avalibleSlots();
      }
    }
  }, [profile]);

  useEffect(() => {
    let TournamentList = async () => {
      let res = await GetTournamentList();
      if (res.status) {
      } else {
        Swal.fire({
          title: "No Tournament is active currently.",
          text: "There is no tournament going on now.",
          icon: "error",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: true,
          cancelButtonColor: "#d33",
          cancelButtonText: "Close",
        }).then(async (result) => {
          navigate("/dashboard");
        });
      }
    };
    let playerEnrolledSports = async () => {
      let res = await playerEnrolledSportsAPI({});
      if (res && res.data && res.data.data) {
        setEnrolled(res.data.data);
        const isAnySportEnrolled = Object.values(res.data.data).some(
          (value) => value === true
        );
        setenrolledTeam(isAnySportEnrolled);
        // setEnrolledSport(prevState => {
        //     let updatedState = { ...prevState };

        //     if (res.data.data.badminton) {
        //         updatedState.badminton = true;
        //     }  if (res.data.data.table_tennis ) {
        //         updatedState.table_tenis = true;
        //     }  if (res.data.data.bowling) {
        //         updatedState.bowling = true;
        //     }  if (res.data.data.twok_run ) {
        //         updatedState.twok_run = true;
        //     }
        //     return updatedState;
        // });
      } else {
        console.error("Enrolled sports data is missing", res);
      }
    };
    TournamentList();
    playerEnrolledSports();
  }, []);

  useEffect(() => {
    let callAPI = async () => {
      let res = await getSetting();

      if (res.status) {
        res.data.map((entry, index) => {
          if (entry.value == "false" && entry.name === "tournament_register") {
            Swal.fire({
              title: dynamicHeading.registration_closed
                ? dynamicHeading.registration_closed.title
                  ? dynamicHeading.registration_closed.title
                  : "Tournament registration are closed"
                : "Tournament registration are closed",
              text: dynamicHeading.registration_closed
                ? dynamicHeading.registration_closed.value
                : "You are late, tournament registration is closed, try again next time.",
              icon: "error",
              allowOutsideClick: false,
              allowEscapeKey: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                navigate("/dashboard");
              }
            });
          }
        });
      } else {
        // setIsOn(null);
        enqueueSnackbar("unable to fetch setting", {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    };
    if (tournament != "") {
      callAPI();
    }
  }, [tournament]);

  useEffect(() => {
    if (showsport != null) setSportSelection(showsport);
    if (sportSelection.batminton == true) {
      SetSelectBatminton({
        title: "Selected",
        value: "cancel",
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }
    if (sportSelection.tableTenis == true) {
      SetSelectTableTenis({
        title: "Selected",
        value: "cancel",
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }
    if (sportSelection.bowling == true) {
      SetSelectBowling({
        title: "Selected",
        value: "cancel",
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }
    if (sportSelection.twokRun == true) {
      SetSelect2k_run({
        title: "Selected",
        value: "cancel",
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }
  }, [showsport]);

  useEffect(() => {
    showsport = JSON.parse(localStorage.getItem("showsport"));

    if (showsport != null) {
      if (showsport.batminton == true) {
        SetSelectBatminton({
          title: "Selected",
          value: "cancel",
          style: {
            backgroundColor: "rgba(23, 92, 30, 1)",
            color: "white",
          },
        });
      }
      if (showsport.tableTenis == true) {
        SetSelectTableTenis({
          title: "Selected",
          value: "cancel",
          style: {
            backgroundColor: "rgba(23, 92, 30, 1)",
            color: "white",
          },
        });
      }
      if (showsport.bowling == true) {
        SetSelectBowling({
          title: "Selected",
          value: "cancel",
          style: {
            backgroundColor: "rgba(23, 92, 30, 1)",
            color: "white",
          },
        });
      }
      if (showsport.twokRun == true) {
        SetSelect2k_run({
          title: "Selected",
          value: "cancel",
          style: {
            backgroundColor: "rgba(23, 92, 30, 1)",
            color: "white",
          },
        });
      }
    }

    let callAPI = async () => {
      let res = await CurrentTournament();
      if (res.data.status) {
        setTournament(res.data.data.id);
        localStorage.setItem("tournamentID", res.data.data.id);
      }
    };

    let getSports = async () => {
      let res = await enrolledUser();
      if (res.status) {
        navigate("/dashboard");
        enqueueSnackbar("you have already enrolled in tournament", {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    };

    let callAPIDynamictext = async () => {
      let formData = {
        data: null,
      };
      let res = await FilterDynamicText(formData);
      if (res.data.status) {
        setDynamicHeading(res.data.data);
      }
    };
    callAPI();
    callAPI();
    callAPIDynamictext();
    // getSports() commented for flow test
  }, []);

  useEffect(() => {
    let callAPI = async () => {
      let res = await Profile();
      if (res.status) {
        setProfile(res.data);
      }
    };

    callAPI();
  }, []);

  useEffect(() => {
    if (profile != null) {
    }
  }, [profile]);
  useEffect(() => {
    let avalibleSlots = async () => {
      setloaderStatus(true);
      let formData = {
        team: SelectedTeam,
        gender: true,
      };
      let res = await avalibleSlotsAPI(formData);

      if (res.status) {
        setloaderStatus(false);
        if (res.data.TotalResult.badminton > 0) {
          SetSelectBatminton({
            title: "Available",
            value: res.data.TotalResult.badminton,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBadmintionSlot(res.data.TotalResult.badminton);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.badminton == 0) {
          SetSelectBatminton({
            title: "Unavailable",
            value: res.data.TotalResult.badminton,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBadmintionSlot(res.data.TotalResult.badminton);
          setWaitListActive((prevState) => ({
            ...prevState,
            badminton: {
              waitList: true,
              sport: "badminton",
              round: "group_stage",
            },
          }));
        }
        if (res.data.TotalResult.table_tenis > 0) {
          SetSelectTableTenis({
            title: "Available",
            value: res.data.TotalResult.table_tenis,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setTableTenniSlot(res.data.TotalResult.table_tenis);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.table_tenis == 0) {
          SetSelectTableTenis({
            title: "Unavailable",
            value: res.data.TotalResult.table_tenis,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setTableTenniSlot(res.data.TotalResult.table_tenis);
          setWaitListActive((prevState) => ({
            ...prevState,
            table_tenis: {
              waitList: true,
              sport: "table_tenis",
              round: "group_stage",
            },
          }));
        }

        //bowling
        if (res.data.TotalResult.bowling > 0) {
          SetSelectBowling({
            title: "Available",
            value: res.data.TotalResult.bowling,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBowlingSlot(res.data.TotalResult.bowling);
          setLogoutCount(logoutCount + 1);
        }

        if (res.data.TotalResult.bowling == 0) {
          SetSelectBowling({
            title: "Unavailable",
            value: res.data.TotalResult.bowling,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          setBowlingSlot(res.data.TotalResult.bowling);
          setWaitListActive((prevState) => ({
            ...prevState,
            bowling: {
              waitList: true,
              sport: "bowling",
              round: "round_1",
            },
          }));
        }

        //2k_run
        if (res.data.TotalResult.twok_run > 0) {
          SetSelect2k_run({
            title: "Available",
            value: res.data.TotalResult.twok_run,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          settwokRuniSlot(res.data.TotalResult.twok_run);
          setLogoutCount(logoutCount + 1);
        }
        if (res.data.TotalResult.twok_run == 0) {
          SetSelect2k_run({
            title: "Unavailable",
            value: res.data.TotalResult.twok_run,
            style: {
              color: "rgba(23, 92, 30, 1)",
              fontFamily: "Roboto",
              border: "1px solid rgba(23, 92, 30, 1)",
              backgroundColor: "#056C3C",
              color: "#fff",
            },
          });
          settwokRuniSlot(res.data.TotalResult.twok_run);
          setWaitListActive((prevState) => ({
            ...prevState,
            twok_run: {
              waitList: true,
              sport: "2k_run",
              round: "round_1",
            },
          }));
        }
      }
    };
    if (SelectedTeam != null) {
      avalibleSlots();
    }
  }, [SelectedTeam]);
  let waitlistRegisterAPI = async (game) => {
    setloaderStatus(true);

    let FormData = {
      game_type: game,
      type: "waiting",
      tournament_id: tournament,
      team:
        profile.corporate_email === "" ? SelectedTeam : profile.corporate_email,
    };
    if (profile.corporate_email === "") {
      let formDataProfile = {
        id: profile.id,
        corporate_email: SelectedTeam,
      };
      let resData = await UpdateProfile(formDataProfile);
      if (resData.data.status) {
      } else {
        enqueueSnackbar(resData.data.message, {
          variant: "error",
          action: (key) => (
            <button
              className="toast_close_btn"
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        });
      }
    }
    let res = await enrolledWaiting(FormData);
    if (res.data.status) {
      setloaderStatus(false);
      // enqueueSnackbar('Wating List joined Successfully', { variant: 'success' })
      // window.location.reload();
      return true;
    } else {
      setloaderStatus(false);
      enqueueSnackbar("unable to join Wating List ", {
        variant: "error",
        action: (key) => (
          <button
            className="toast_close_btn"
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      });
      return false;
    }
  };

  let waitListExitAPI = async (game) => {
    setloaderStatus(true);

    let FormData = {
      game_type: game,
      type: "waiting",
      tournament_id: tournament,
    };
    let res = await ExitWaitList(FormData);
    if (res.data.status) {
      setloaderStatus(false);
      // window.location.reload();
      // enqueueSnackbar('Wating List Exited Successfully', { variant: 'success' })
      return true;
    } else {
      setloaderStatus(false);
      enqueueSnackbar("unable to exit Wating List ", {
        variant: "error",
        action: (key) => (
          <button
            className="toast_close_btn"
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      });
      return false;
    }
  };

  // useEffect(() => {

  //     // Define an async function to handle API calls
  //     const callAPI = async () => {
  //         // Convert the Object.entries to an array of promises
  //         const promises = Object.entries(waitListActive).map(async ([key, sport]) => {
  //             if (sport.waitList) {
  //                 // Prepare the request data
  //                 const formData = {
  //                     tournament_id: tournament,
  //                     game_type: sport.sport,
  //                     waitList: sport.waitList,
  //                     round: sport.round
  //                 };

  //                 // Make the API call
  //                 setloaderStatus(true)
  //                 const res = await IsMatchDone(formData);
  //                 console.log(res);

  //                 if (res.data.status) {
  //                 setloaderStatus(false)

  //                     // Update the corresponding state based on the sport
  //                     if (sport.sport === 'badminton') {

  //                         if (res.data.data) {
  //                             SetSelectBatminton({
  //                             title:'Join Waitlist',
  //                             value:0,
  //                             style:{
  //                                 backgroundColor:'#fab92c',
  //                                 color:'white'
  //                             },
  //                             });;
  //                         }
  //                         console.log("bad +++++", res.data.data);
  //                     } else if (sport.sport === 'table_tenis') {
  //                         if (res.data.data) {
  //                             SetSelectTableTenis({
  //                                 title:'Join Waitlist',
  //                                 value:0,
  //                                 style:{
  //                                     backgroundColor:'#fab92c',
  //                                     color:'white'
  //                                 },
  //                             })
  //                         }
  //                         console.log("table +++++", res.data.data);
  //                     } else if (sport.sport === 'bowling') {
  //                         if (res.data.data) {
  //                             SetSelectBowling(
  //                                 {
  //                                     title:'Join Waitlist',
  //                                     value:0,
  //                                     style:{
  //                                         backgroundColor:'#fab92c',
  //                                         color:'white'
  //                                     },
  //                                 }
  //                             )
  //                         }
  //                         console.log("bow +++++", res.data.data);
  //                     } else if (sport.sport === '2k_run') {
  //                         if (res.data.data) {
  //                             SetSelect2k_run(
  //                                 {
  //                                     title:'Join Waitlist',
  //                                     value:0,
  //                                     style:{
  //                                         backgroundColor:'#fab92c',
  //                                         color:'white'
  //                                     },
  //                                 }
  //                             )
  //                         }
  //                         console.log("2k +++++", res.data.data);
  //                     }

  //                 } else {
  //                 setloaderStatus(false)

  //                 }
  //             }
  //         });

  //         // Wait for all promises to complete
  //         let completed = await Promise.all(promises);
  //         settemp(true)
  //         let CallAPIWaitList = async () => {
  //             console.log("APi callrd");

  //             let formData = {
  //                 "tournament_id": tournament
  //             }
  //             setloaderStatus(true)
  //             let res = await WaitlistPlayersAPI(formData)

  //             if (res.data.status) {
  //                 setloaderStatus(false)

  //                 // if (logoutCount == 0) {
  //                 //     Swal.fire({
  //                 //         title: "You have joined waitlist Already ",
  //                 //         text: "You are already enrolled in waitlist , sit back  we will inform  you via email once slots are available",
  //                 //         icon: "success",
  //                 //         confirmButtonColor: "#3085d6",
  //                 //         confirmButtonText: "Logout",
  //                 //         allowOutsideClick: false,
  //                 //         allowEscapeKey: false

  //                 //       }).then((result) => {
  //                 //         if (result.isConfirmed) {
  //                 //             window.location.href = '/logout'

  //                 //         }
  //                 //     });
  //                 // } else {
  //                 //     // res.data.data.map((sport, index) => {
  //                 //     //     if (sport == 'badminton') {
  //                 //     //         SetSelectBatminton(
  //                 //     //             {
  //                 //     //                 title:'Joined waitlist',
  //                 //     //                 value:0,
  //                 //     //                 style:{
  //                 //     //                     backgroundColor:'#5856d6',
  //                 //     //                     color:'white'
  //                 //     //                 },
  //                 //     //             }
  //                 //     //         )
  //                 //     //     } else if (sport == 'table_tenis') {
  //                 //     //         SetSelectTableTenis(
  //                 //     //             {
  //                 //     //                 title:'Joined waitlist',
  //                 //     //                 value:0,
  //                 //     //                 style:{
  //                 //     //                     backgroundColor:'#5856d6',
  //                 //     //                     color:'white'
  //                 //     //                 },
  //                 //     //             }
  //                 //     //         )
  //                 //     //     }

  //                 //     //     else if (sport == 'bowling') {
  //                 //     //         SetSelectBowling(
  //                 //     //             {
  //                 //     //                 title:'Joined waitlist',
  //                 //     //                 value:0,
  //                 //     //                 style:{
  //                 //     //                     backgroundColor:'#5856d6',
  //                 //     //                     color:'white'
  //                 //     //                 },
  //                 //     //             }
  //                 //     //         )
  //                 //     //     } else if (sport =='2k_run') {
  //                 //     //         SetSelect2k_run(
  //                 //     //             {
  //                 //     //                 title:'Joined waitlist',
  //                 //     //                 value:0,
  //                 //     //                 style:{
  //                 //     //                     backgroundColor:'#5856d6',
  //                 //     //                     color:'white'
  //                 //     //                 },
  //                 //     //             }
  //                 //     //         )
  //                 //     //     }
  //                 //     // })
  //                 // }
  //                 res.data.data.map((Entry, index) => {
  //                     if (Entry.game_type == 'badminton') {
  //                         SetSelectBatminton(
  //                             {
  //                                 title:'Joined Waitlist',
  //                                 value:0,
  //                                 style:{
  //                                     backgroundColor:'#5856d6',
  //                                     color:'white'
  //                                 },
  //                             }
  //                         )
  //                     } else if (Entry.game_type == 'table_tenis') {
  //                         console.log("im herererere");

  //                         SetSelectTableTenis(
  //                             {
  //                                 title:'Joined Waitlist',
  //                                 value:0,
  //                                 style:{
  //                                     backgroundColor:'#5856d6',
  //                                     color:'white'
  //                                 },
  //                             }
  //                         )
  //                     }

  //                     else if (Entry.game_type == 'bowling') {
  //                         SetSelectBowling(
  //                             {
  //                                 title:'Joined Waitlist',
  //                                 value:0,
  //                                 style:{
  //                                     backgroundColor:'#5856d6',
  //                                     color:'white'
  //                                 },
  //                             }
  //                         )
  //                     } else if (Entry.game_type =='2k_run') {
  //                         SetSelect2k_run(
  //                             {
  //                                 title:'Joined Waitlist',
  //                                 value:0,
  //                                 style:{
  //                                     backgroundColor:'#5856d6',
  //                                     color:'white'
  //                                 },
  //                             }
  //                         )
  //                     }
  //                 })

  //             } else {
  //                 setloaderStatus(false)

  //             }
  //         }
  //         if (temp == true) {
  //             console.log(temp);

  //             CallAPIWaitList()
  //         }

  //     };

  //     // Call the async function
  //     callAPI();
  // }, [waitListActive,temp]);

  useEffect(() => {
    // Define an async function to handle API calls
    const callAPI = async () => {
      try {
        // Start loader
        // setloaderStatus(true)

        // Convert the Object.entries to an array of promises
        const promises = Object.entries(waitListActive).map(
          async ([key, sport]) => {
            if (sport.waitList) {
              // Prepare the request data
              const formData = {
                tournament_id: tournament,
                game_type: sport.sport,
                waitList: sport.waitList,
                round: sport.round,
              };

              // Make the API call
              const res = await IsMatchDone(formData);

              if (res.data.status) {
                // Update the corresponding state based on the sport
                if (
                  sport.sport === "badminton" &&
                  res.data.data &&
                  badmintionSlot == 0
                ) {
                  SetSelectBatminton({
                    title: "Join Waitlist",
                    value: 0,
                    style: {
                      backgroundColor: "transparent",
                      color: "white",
                      padding: "4px",
                    },
                  });
                } else if (
                  sport.sport === "table_tenis" &&
                  res.data.data &&
                  tableTennisSlot == 0
                ) {
                  SetSelectTableTenis({
                    title: "Join Waitlist",
                    value: 0,
                    style: {
                      backgroundColor: "transparent",
                      color: "white",
                      padding: "4px",
                    },
                  });
                } else if (
                  sport.sport === "bowling" &&
                  res.data.data &&
                  bowlingSlot == 0
                ) {
                  SetSelectBowling({
                    title: "Join Waitlist",
                    value: 0,
                    style: {
                      backgroundColor: "transparent",
                      color: "white",
                      padding: "4px",
                    },
                  });
                } else if (
                  sport.sport === "2k_run" &&
                  res.data.data &&
                  twokRunSlot == 0
                ) {
                  SetSelect2k_run({
                    title: "Join Waitlist",
                    value: 0,
                    style: {
                      backgroundColor: "transparent",
                      color: "white",
                      padding: "4px",
                    },
                  });
                }
              }
            }
          }
        );

        // Wait for all promises to complete
        await Promise.all(promises);

        // Call the second API after the first set is done
        await CallAPIWaitList();
      } catch (error) {
        console.error("Error in API call:", error);
      } finally {
        // Stop loader
        setloaderStatus(false);
      }
    };
    const CallAPIWaitList = async () => {
      try {
        let formData = {
          tournament_id: tournament,
        };

        const res = await WaitlistPlayersAPI(formData);

        if (res.data.status) {
          if (res.data.data.length > 0) {
            setwaitListTeam(true);
          }
          res.data.data.forEach(async (Entry) => {
            if (Entry.game_type === "badminton") {
              let formData = {
                team:
                  profile.corporate_email === ""
                    ? SelectedTeam
                    : profile.corporate_email,
                gender: true,
              };
              let avalibleSlotsAPIRes = await avalibleSlotsAPI(formData);
              if (avalibleSlotsAPIRes.data.TotalResult.badminton > 0) {
              } else {
                SetSelectBatminton({
                  title: "Exit Waitlist",
                  value: 0,
                  style: {
                    backgroundColor: "#FF0000",
                    color: "white",
                  },
                });
                setEnableSubmit(true);
              }
            } else if (Entry.game_type === "table_tenis") {
              let formData = {
                team:
                  profile.corporate_email === ""
                    ? SelectedTeam
                    : profile.corporate_email,
                gender: true,
              };
              let avalibleSlotsAPIRes = await avalibleSlotsAPI(formData);

              if (avalibleSlotsAPIRes.data.TotalResult.table_tenis > 0) {
              } else {
                SetSelectTableTenis({
                  title: "Exit Waitlist",
                  value: 0,
                  style: {
                    backgroundColor: "#FF0000",
                    color: "white",
                  },
                });
                setEnableSubmit(true);
              }
            } else if (Entry.game_type === "bowling") {
              SetSelectBowling({
                title: "Exit Waitlist",
                value: 0,
                style: {
                  backgroundColor: "#FF0000",
                  color: "white",
                },
              });
              setEnableSubmit(true);
            } else if (Entry.game_type === "2k_run") {
              SetSelect2k_run({
                title: "Exit Waitlist",
                value: 0,
                style: {
                  backgroundColor: "#FF0000",
                  color: "white",
                },
              });
              setEnableSubmit(true);
            }
          });
        }
      } catch (error) {
        console.error("Error in WaitlistPlayersAPI:", error);
      }
    };

    // Call the async function
    callAPI();
  }, [waitListActive]);

  useEffect(() => {
    if (logoutCount != 0) {
      if (logoutCount == 4) {
        setLogout(false);
      }
      if (logoutCount > 0 && logoutCount < 4) {
        setLogout(true);
      }
    }
  }, [logoutCount]);

  useEffect(() => {
    if (
      selectBatminton != null &&
      selectTableTenis != null &&
      selectBowling != null &&
      select2k_run != null
    ) {
      let allUnvailable = {
        badminton: false,
        table_tenis: false,
        bowling: false,
        twokrun: false,
      };
      let allEnrolled = {
        badminton: false,
        table_tenis: false,
        bowling: false,
        twokrun: false,
      };
      // selectBatminton.title ===  'Unavailable' ? allUnvailable.badminton = true: false
      // selectTableTenis.title ===  'Unavailable' ? allUnvailable.table_tenis = true: false
      // selectBowling.title ===  'Unavailable' ? allUnvailable.bowling = true: false
      // select2k_run.title ===  'Unavailable' ? allUnvailable.twokrun = true: false
      if (selectBatminton.title === "Unavailable") {
        allUnvailable.badminton = true;
      }

      if (selectTableTenis.title === "Unavailable") {
        allUnvailable.table_tenis = true;
      }

      if (selectBowling.title === "Unavailable") {
        allUnvailable.bowling = true;
      }

      if (select2k_run.title === "Unavailable") {
        allUnvailable.twokrun = true;
      }

      // Enrolled
      if (selectBatminton.title === "Enrolled") {
        allEnrolled.badminton = true;
      }

      if (selectTableTenis.title === "Enrolled") {
        allEnrolled.table_tenis = true;
      }

      if (selectBowling.title === "Enrolled") {
        allEnrolled.bowling = true;
      }

      if (select2k_run.title === "Enrolled") {
        allEnrolled.twokrun = true;
      }
      let areAllTrue = Object.values(allUnvailable).every(
        (value) => value === true
      );
      let areAllEnrolledTrue = Object.values(allEnrolled).every(
        (value) => value === true
      );
      if (areAllTrue || areAllEnrolledTrue) {
        setDashboardRedirect(true);
      } else {
        setDashboardRedirect(false);
      }
    }
  }, [selectBatminton, selectTableTenis, selectBowling, select2k_run]);
  const HandelChange = (event) => {
    const { name, value, checked } = event.target;
    if (name === "sports") {
      const updatedSports = [...FormData.sports];
      if (checked) {
        updatedSports.push(value);
      } else {
        const index = updatedSports.indexOf(value);
        if (index !== -1) {
          updatedSports.splice(index, 1);
        }
      }
      // Update the FormData state with the new sports array
      setFormData({ ...FormData, sports: updatedSports });
    } else {
      // For other input fields, update the FormData state normally
      setFormData({ ...FormData, [name]: value });
    }
  };

  // const handleTeamChange = (event) => {
  //   setSelectedTeam(event.target.value);
  // }

  const HandelSubmit = async (event) => {
    if (logoutCount === 0) {
      navigate(`/dashboard`);
    } else if (
      logoutCount > 0 &&
      Object.values(sportSelection).every((value) => value === false)
    ) {
      navigate(`/dashboard`);
    } else {
      let formData = {
        id: profile.id,
        corporate_email: SelectedTeam,
      };
      if (profile.corporate_email === "") {
        if (formData.corporate_email != null) {
          let res = await UpdateProfile(formData);
          if (res.data.status) {
          } else {
            enqueueSnackbar(res.data.message, {
              variant: "error",
              action: (key) => (
                <button
                  className="toast_close_btn"
                  onClick={() => {
                    // Close the Snackbar
                    closeSnackbar(key);
                  }}
                >
                  X
                </button>
              ),
            });
          }
        }
      }
      if (enrollToken == null) {
        Swal.fire({
          title: "Unable to fetch enroll token",
          text: "we are facing issue in getting enrollement token . please try again later .",
          icon: "error",
          allowOutsideClick: false,
          allowEscapeKey: false,
        }).then(async (result) => {
          navigate("/dashboard");
        });
      } else {
        var queryParams = "";
        queryParams = new URLSearchParams({
          badminton: sportSelection.batminton,
          tennis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twok_run: sportSelection.twokRun,
          enroll_token: enrollToken,
        }).toString();
        localStorage.setItem(
          "showsport",
          JSON.stringify({
            badminton: sportSelection.batminton,
            tennis: sportSelection.tableTenis,
            bowling: sportSelection.bowling,
            twokRun: sportSelection.twokRun,
            enroll_token: enrollToken,
          })
        );
        navigate(`/game-plan?${queryParams}`);
      }
    }
  };

  function handleSelectSport(Sport, Value) {
    let selectedValue = {
      backgroundColor: "rgba(23, 92, 30, 1)",
      color: "white",
    };

    let avalibleValue = {
      color: "rgba(23, 92, 30, 1)",
      fontFamily: "Roboto",
      border: "1px solid rgba(23, 92, 30, 1)",
      backgroundColor: "#056C3C",
      color: "#fff",
    };

    if (Sport == "badminton") {
      if (Value == "Available") {
        SetSelectBatminton({
          title: "Selected",
          value: "cancel",
          style: selectedValue,
        });

        setSportSelection({
          batminton: true,
          tableTenis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twokRun: sportSelection.twokRun,
        });
      } else if (Value === "Join Waitlist") {
        Swal.fire({
          title: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.title
            : "Are you sure to join waitlist?",
          text: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.value
            : "After joining, we will inform you via email when the slots are available",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Join",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            SetSelectBatminton({
              title: "Exit Waitlist",
              value: 0,
              style: {
                backgroundColor: "#FF0000",
                color: "white",
              },
            });
            setEnableSubmit(true);

            let res = await waitlistRegisterAPI("badminton");
            if (res) {
              let propertirs = {
                title: "Waitlist joined successfully",
                text: "You have been enrolled in waitling list, we will notify you once the slot is available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });

        // setSportSelection({batminton:true,tableTenis:sportSelection.tableTenis, bowling: sportSelection.bowling, twokRun: sportSelection.twokRun})
      } else if (Value === "Exit Waitlist") {
        Swal.fire({
          title: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.title
            : "Are you sure to exit waitlist?",
          text: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.value
            : "After exit, you will not be informed via email when the slots are available.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            // SetSelectBatminton({
            //   title: 'Join Waitlist',
            //   value: badmintionSlot,
            //   style: { backgroundColor: '#fab92c', color: 'white' }
            // })
            // setEnableSubmit(true)

            let res = await waitListExitAPI("badminton");
            if (res) {
              let propertirs = {
                title: "Waitlist Exited successfully",
                text: "You have been exited from waitling list,  you will not be informed via email when the slots are available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  SetSelectBatminton({
                    title: "Join Waitlist",
                    value: badmintionSlot,
                    style: { backgroundColor: "transparent", color: "white" },
                  });
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });
      } else if (Value === "cancel") {
        SetSelectBatminton({
          title: "Available",
          value: badmintionSlot,
          style: avalibleValue,
        });
        setSportSelection({
          batminton: false,
          tableTenis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twokRun: sportSelection.twokRun,
        });
      } else {
        if (waitListActive["badminton"].waitList) {
          SetSelectBatminton({
            title: "Join Waitlist",
            value: badmintionSlot,
            style: {
              backgroundColor: "transparent",
              color: "white",
              padding: "4px",
            },
          });
          setSportSelection({
            batminton: false,
            tableTenis: sportSelection.tableTenis,
            bowling: sportSelection.bowling,
            twokRun: sportSelection.twokRun,
          });
        } else {
          SetSelectBatminton({
            title: "Available",
            value: badmintionSlot,
            style: avalibleValue,
          });
          setSportSelection({
            batminton: false,
            tableTenis: sportSelection.tableTenis,
            bowling: sportSelection.bowling,
            twokRun: sportSelection.twokRun,
          });
        }
      }
    } else if (Sport == "tableTenis") {
      if (Value == "Available") {
        SetSelectTableTenis({
          title: "Selected",
          value: "cancel",
          style: selectedValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: true,
          bowling: sportSelection.bowling,
          twokRun: sportSelection.twokRun,
        });
      } else if (Value === "Join Waitlist") {
        Swal.fire({
          title: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.title
            : "Are you sure to join waitlist?",
          text: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.value
            : "After joining, we will inform you via email when the slots are available",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Join",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            SetSelectTableTenis({
              title: "Exit Waitlist",
              value: 0,
              style: {
                backgroundColor: "#FF0000",
                color: "white",
              },
            });
            setEnableSubmit(true);

            let res = await waitlistRegisterAPI("table_tenis");
            if (res) {
              let propertirs = {
                title: "Waitlist joined successfully",
                text: "You have been enrolled in waitling list, we will notify you once the slot is available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });

        // setSportSelection({batminton:sportSelection.batminton,tableTenis:true, bowling: sportSelection.bowling,twokRun: sportSelection.twokRun})
      } else if (Value === "Exit Waitlist") {
        Swal.fire({
          title: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.title
            : "Are you sure to exit waitlist?",
          text: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.value
            : "After exit, you will not be informed via email when the slots are available.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            // SetSelectTableTenis({
            //   title: 'Join Waitlist',
            //   value: tableTennisSlot,
            //   style: { backgroundColor: '#fab92c', color: 'white' }
            // })
            // setEnableSubmit(true)

            let res = await waitListExitAPI("table_tenis");
            if (res) {
              let propertirs = {
                title: "Waitlist Exited successfully",
                text: "You have been exited from waitling list,  you will not be informed via email when the slots are available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  SetSelectTableTenis({
                    title: "Join Waitlist",
                    value: tableTennisSlot,
                    style: { backgroundColor: "transparent", color: "white" },
                  });
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });
      } else if (Value === "cancel") {
        SetSelectTableTenis({
          title: "Available",
          value: tableTennisSlot,
          style: avalibleValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: false,
          bowling: sportSelection.bowling,
          twokRun: sportSelection.twokRun,
        });
      } else {
        if (waitListActive["table_tenis"].waitList) {
          SetSelectTableTenis({
            title: "Join Waitlist",
            value: tableTennisSlot,
            style: {
              backgroundColor: "transparent",
              color: "white",
              padding: "4px",
            },
          });
          setSportSelection({
            batminton: sportSelection.batminton,
            tableTenis: false,
            bowling: sportSelection.bowling,
            twokRun: sportSelection.twokRun,
          });
        } else {
          SetSelectTableTenis({
            title: "Available",
            value: tableTennisSlot,
            style: avalibleValue,
          });
          setSportSelection({
            batminton: sportSelection.batminton,
            tableTenis: false,
            bowling: sportSelection.bowling,
            twokRun: sportSelection.twokRun,
          });
        }
      }
    } else if (Sport == "bowling") {
      if (Value == "Available") {
        SetSelectBowling({
          title: "Selected",
          value: "cancel",
          style: selectedValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: sportSelection.tableTenis,
          bowling: true,
          twokRun: sportSelection.twokRun,
        });
      } else if (Value === "Join Waitlist") {
        Swal.fire({
          title: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.title
            : "Are you sure to join waitlist?",
          text: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.value
            : "After joining, we will inform you via email when the slots are available",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Join",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            SetSelectBowling({
              title: "Exit Waitlist",
              value: 0,
              style: {
                backgroundColor: "#FF0000",
                color: "white",
              },
            });
            setEnableSubmit(true);

            let res = await waitlistRegisterAPI("bowling");
            if (res) {
              let propertirs = {
                title: "Waitlist joined successfully",
                text: "You have been enrolled in waitling list, we will notify you once the slot is available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });
        // setSportSelection({batminton:sportSelection.batminton,tableTenis:sportSelection.tableTenis, bowling: true, twokRun: sportSelection.twokRun})
      } else if (Value === "Exit Waitlist") {
        Swal.fire({
          title: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.title
            : "Are you sure to exit waitlist?",
          text: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.value
            : "After exit, you will not be informed via email when the slots are available.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            // SetSelectBowling({
            //   title: 'Join Waitlist',
            //   value: bowlingSlot,
            //   style: { backgroundColor: '#fab92c', color: 'white' }
            // })
            // setEnableSubmit(true)

            let res = await waitListExitAPI("bowling");
            if (res) {
              let propertirs = {
                title: "Waitlist Exited successfully",
                text: "You have been exited from waitling list,  you will not be informed via email when the slots are available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  SetSelectBowling({
                    title: "Join Waitlist",
                    value: bowlingSlot,
                    style: { backgroundColor: "transparent", color: "white" },
                  });
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });
      } else if (Value === "cancel") {
        SetSelectBowling({
          title: "Available",
          value: bowlingSlot,
          style: avalibleValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: sportSelection.tableTenis,
          bowling: true,
          twokRun: sportSelection.twokRun,
        });
      } else {
        if (waitListActive["bowling"].waitList) {
          SetSelectBowling({
            title: "Join Waitlist",
            value: bowlingSlot,
            style: {
              backgroundColor: "transparent",
              color: "white",
              padding: "4px",
            },
          });

          setSportSelection({
            batminton: sportSelection.batminton,
            tableTenis: sportSelection.tableTenis,
            bowling: false,
            twokRun: sportSelection.twokRun,
          });
        } else {
          SetSelectBowling({
            title: "Available",
            value: bowlingSlot,
            style: avalibleValue,
          });
          setSportSelection({
            batminton: sportSelection.batminton,
            tableTenis: sportSelection.tableTenis,
            bowling: false,
            twokRun: sportSelection.twokRun,
          });
        }
      }
    } else if (Sport == "twok_run") {
      if (Value == "Available") {
        SetSelect2k_run({
          title: "Selected",
          value: "cancel",
          style: selectedValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twokRun: true,
        });
      } else if (Value === "Join Waitlist") {
        Swal.fire({
          title: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.title
            : "Are you sure to join waitlist?",
          text: dynamicHeading.join_waitlist
            ? dynamicHeading.join_waitlist.value
            : "After joining, we will inform you via email when the slots are available",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Join",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            SetSelect2k_run({
              title: "Exit Waitlist",
              value: 0,
              style: {
                backgroundColor: "#FF0000",
                color: "white",
              },
            });
            setEnableSubmit(true);

            let res = await waitlistRegisterAPI("2k_run");
            if (res) {
              let propertirs = {
                title: "Waitlist joined successfully",
                text: "You have been enrolled in waitling list, we will notify you once the slot is available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });

        // setSportSelection({batminton:sportSelection.batminton,tableTenis:sportSelection.tableTenis, bowling: sportSelection.bowling, twokRun: true})
      } else if (Value === "Exit Waitlist") {
        Swal.fire({
          title: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.title
            : "Are you sure to exit waitlist?",
          text: dynamicHeading.exit_waitlist
            ? dynamicHeading.exit_waitlist.value
            : "After exit, you will not be informed via email when the slots are available.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, Exit",
          cancelButtonText: "Close",
        }).then(async (result) => {
          if (result.isConfirmed) {
            // SetSelect2k_run({
            //   title: 'Join Waitlist',
            //   value: twokRunSlot,
            //   style: { backgroundColor: '#fab92c', color: 'white' }
            // })
            // setEnableSubmit(true)

            let res = await waitListExitAPI("2k_run");
            if (res) {
              let propertirs = {
                title: "Waitlist Exited successfully",
                text: "You have been exited from waitling list,  you will not be informed via email when the slots are available",
                icon: "success",
                confirmButtonColor: "#3085d6",
                allowOutsideClick: false,
                allowEscapeKey: false,

                confirmButtonText: "OK",
              };
              Swal.fire(propertirs).then((result) => {
                if (result.isConfirmed) {
                  SetSelect2k_run({
                    title: "Join Waitlist",
                    value: twokRunSlot,
                    style: { backgroundColor: "transparent", color: "white" },
                  });
                  window.location.reload();
                }
              });
            }
            return res;
          }
        });
      } else if (Value === "cancel") {
        SetSelect2k_run({
          title: "Available",
          value: twokRunSlot,
          style: avalibleValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twokRun: true,
        });
      } else {
        if (waitListActive["twok_run"].waitList) {
          SetSelect2k_run({
            title: "Join Waitlist",
            value: twokRunSlot,
            style: {
              backgroundColor: "transparent",
              color: "white",
              padding: "4px",
            },
          });
          setSportSelection({
            batminton: sportSelection.batminton,
            tableTenis: sportSelection.tableTenis,
            bowling: sportSelection.bowling,
            twokRun: false,
          });
        }
        SetSelect2k_run({
          title: "Available",
          value: twokRunSlot,
          style: avalibleValue,
        });
        setSportSelection({
          batminton: sportSelection.batminton,
          tableTenis: sportSelection.tableTenis,
          bowling: sportSelection.bowling,
          twokRun: false,
        });
      }
    }
  }

  let LogoutPlayer = () => {
    navigate("/logout");
  };

  useEffect(() => {
    if (enrolled.badminton) {
      SetSelectBatminton({
        title: "Enrolled",
        value: 0,
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }

    if (enrolled.table_tennis) {
      SetSelectTableTenis({
        title: "Enrolled",
        value: 0,
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }

    if (enrolled.bowling) {
      SetSelectBowling({
        title: "Enrolled",
        value: 0,
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }

    if (enrolled.twok_run) {
      SetSelect2k_run({
        title: "Enrolled",
        value: 0,
        style: {
          backgroundColor: "rgba(23, 92, 30, 1)",
          color: "white",
        },
      });
    }
  }, [
    enrolled,
    waitListActive,
    selectBatminton,
    selectTableTenis,
    selectBowling,
    select2k_run,
  ]);

  let handleTeamChange = (e) => {
    setSelectedTeam(e.target.value);
  };
  const formatTitle = (text) => {
    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };
  return (
    <>
      {loaderStatus ? <Loader /> : null}
      <FormContainer classname="col-md-10">
        {/* <h4 className="heading new_heading"><strong>Teams Sports</strong></h4> */}
        <p className="col-desc" style={{ fontWeight: 400, marginTop: "-30px" }}>
          Please upload your profile picture, select your team, and pick the
          sport(s) you’d like to compete in to complete your registration!{" "}
        </p>
        <div className="image new_img">
          {/* <div><img src={manimg}/></div> */}
          <ImageUpload profile={profile} />
          {/* <p className="h5 text-black" style={{ marginTop: '10px', fontWeight:700}}>David Joe</p> */}
        </div>
        <div className="select-sport">
          <p className="h5 text-center mb-2" style={{ fontWeight: 700 }}>
            Select Sports
          </p>
        </div>
        <div className="container">
          <div className="row option-row ">
            <div className="mb-3 px-0">
              {profile && profile.corporate_email === "" ? (
                teams.length > 0 && enrolledTeam == false ? (
                  <>
                    <label
                      className="mb-2 input-label"
                      htmlFor="corporateEmail"
                    >
                      Team
                    </label>

                    <select
                      name="corporateEmail"
                      className="mb-4 form-select bg-transparent form-input"
                      onChange={(e) => handleTeamChange(e)}
                      value={SelectedTeam}
                      required
                    >
                      <option
                        value=""
                        disabled
                        style={{ backgroundColor: "#040405" }}
                      >
                        Select a Team
                      </option>
                      {teams.map((entry, index) => (
                        <option
                          key={index}
                          value={entry.domain}
                          style={{ backgroundColor: "#040405" }}
                        >
                          {formatTitle(entry.domain)}
                        </option>
                      ))}
                    </select>
                  </>
                ) : null
              ) : null}
            </div>

            <div className="col-6 upper-col">
              <span className="innerspan" style={{ fontWeight: 400 }}>
                <img
                  src={batminton}
                  className="icons"
                  style={{ color: "#000" }}
                />
              </span>
              <span className="" style={{ fontWeight: 200 }}></span> Badminton
            </div>
            {selectBatminton != null ? (
              <>
                <div className="col-6 upper-col d-flex">
                  <button
                    type="button"
                    class="btn  btn-sm slected-btn btn-1 choose_sport_btn"
                    onClick={() =>
                      handleSelectSport("badminton", selectBatminton.title)
                    }
                    style={selectBatminton.style}
                    disabled={
                      selectBatminton.title == "Unavailable" ||
                      selectBatminton.title == "Enrolled" ||
                      selectBatminton.title == "Selected"
                        ? true
                        : false
                    }
                  >
                    {selectBatminton.title}
                  </button>
                  {selectBatminton.value &&
                    selectBatminton.value == "cancel" && (
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm cancel-btn btn-2 choose_sport_btn"
                        onClick={() =>
                          handleSelectSport("badminton", selectBatminton.value)
                        }
                        disabled={
                          selectBatminton.title == "Unavailable" ||
                          selectBatminton.title == "Join Waitlist" ||
                          selectBatminton.value == 0 ||
                          selectBatminton.title == "Exit Waitlist" ||
                          selectBatminton.title == "Enrolled" ||
                          selectBatminton.title == "Available"
                            ? true
                            : false
                        }
                      >
                        {selectBatminton.value}
                      </button>
                    )}
                </div>
              </>
            ) : null}

            {/* <div className="col-6 upper-col d-flex">
                            <button type="button" class="btn  btn-sm slected-btn btn-1" value="badmintion" onClick={handle1} style={btn1stylebt}>{xB}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle3}>{val1B}</button>
                        </div> */}
            <div className="col-6 lower-col">
              <span className="innerspan" style={{ fontWeight: 400 }}>
                <img
                  src={tabletenis}
                  className="icons"
                  style={{ color: "#000" }}
                />
              </span>
              Table Tennis
            </div>
            {selectTableTenis != null ? (
              <>
                <div className="col-6 lower-col d-flex mb-3">
                  <button
                    type="button"
                    class="btn  btn-sm slected-btn btn-1 choose_sport_btn"
                    onClick={() =>
                      handleSelectSport("tableTenis", selectTableTenis.title)
                    }
                    style={selectTableTenis.style}
                    disabled={
                      selectTableTenis.title == "Unavailable" ||
                      selectTableTenis.title == "Enrolled" ||
                      selectTableTenis.title == "Selected"
                        ? true
                        : false
                    }
                  >
                    {selectTableTenis.title}
                  </button>
                  {selectTableTenis.value &&
                    selectTableTenis.value == "cancel" && (
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-sm cancel-btn btn-2 choose_sport_btn"
                        onClick={() =>
                          handleSelectSport(
                            "tableTenis",
                            selectTableTenis.value
                          )
                        }
                        disabled={
                          selectTableTenis.title == "Unavailable" ||
                          selectTableTenis.title == "Join Waitlist" ||
                          selectTableTenis.value == 0 ||
                          selectTableTenis.title == "Exit Waitlist" ||
                          selectTableTenis.title == "Enrolled" ||
                          selectTableTenis.title == "Available"
                            ? true
                            : false
                        }
                      >
                        {selectTableTenis.value}
                      </button>
                    )}
                  {/* <button type="button" class="btn  btn-sm slected-btn btn-1" onClick={()=>handleSelectSport('table_tanis')} style={btn1stylett}>{xT}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle33}>{val1T}</button> */}
                  {/* <button type="button" class="btn btn btn-sm slected-btn btn-1" onClick={handle2} style={btn2style}>{y}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle4}>{val2}</button> */}
                </div>
              </>
            ) : null}

            {/* // new bowling code */}
            {/* <div className='col-6 lower-col  '>
              <span className='innerspan' style={{ fontWeight: 400 }}>
                <img
                  src={bowling1}
                  className='icons'
                  style={{ color: 'black' }}
                />
              </span>
              Bowling
            </div> */}
            {/* {selectBowling != null ? (
              <>
                <div className='col-6 lower-col d-flex mb-3'>
                  <button
                    type='button'
                    class='btn  btn-sm slected-btn btn-1 choose_sport_btn'
                    onClick={() =>
                      handleSelectSport('bowling', selectBowling.title)
                    }
                    style={selectBowling.style}
                    disabled={
                      selectBowling.title == 'Unavailable' || selectBowling.title == 'Enrolled'|| selectBowling.title == 'Selected'
                        ? true
                        : false
                    }
                  >
                    {selectBowling.title}
                  </button>
                  <button
                    type='button'
                    class='btn btn-outline-secondary btn-sm cancel-btn btn-2 choose_sport_btn'
                    onClick={() =>
                      handleSelectSport('bowling', selectBowling.value)
                    }
                    disabled={
                      selectBowling.title == 'Unavailable' || selectBowling.title == 'Join Waitlist' ||
                        selectBowling.value == 0 || selectBowling.title == 'Exit Waitlist' || selectBowling.title == 'Enrolled' || selectBowling.title == 'Available' ? true : false
                    }
                  >
                    {selectBowling.value}
                  </button> */}
            {/* <button type="button" class="btn  btn-sm slected-btn btn-1" onClick={()=>handleSelectSport('table_tanis')} style={btn1stylett}>{xT}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle33}>{val1T}</button> */}
            {/* <button type="button" class="btn btn btn-sm slected-btn btn-1" onClick={handle2} style={btn2style}>{y}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle4}>{val2}</button> */}
            {/* </div>
              </>
            ) : null} */}

            {/* <div className='col-6 lower-col  '>
              <span className='innerspan' style={{ fontWeight: 400 }}>
                <img src={walk} className='icons' style={{ color: '#000' }} />
              </span>
              2K Run
            </div> */}
            {/* {select2k_run != null ? (
              <>
                <div className='col-6 lower-col d-flex'>
                  <button
                    type='button'
                    class='btn  btn-sm slected-btn btn-1 choose_sport_btn'
                    onClick={() =>
                      handleSelectSport('twok_run', select2k_run.title)
                    }
                    style={select2k_run.style}
                    disabled={
                      select2k_run.title == 'Unavailable' || select2k_run.title == 'Enrolled' || select2k_run.title == 'Selected'
                        ? true
                        : false
                    }
                  >
                    {select2k_run.title}
                  </button>
                  <button
                    type='button'
                    class='btn btn-outline-secondary btn-sm cancel-btn btn-2 choose_sport_btn'
                    onClick={() =>
                      handleSelectSport('twok_run', select2k_run.value)
                    }
                    disabled={
                      select2k_run.title == 'Unavailable' ||
                        select2k_run.value == 0 || select2k_run.title == 'Join Waitlist' || select2k_run.title == 'Exit Waitlist' || select2k_run.title == 'Enrolled' || select2k_run.title == 'Available' ? true : false
                    }
                  >
                    {select2k_run.value}
                  </button> */}
            {/* <button type="button" class="btn  btn-sm slected-btn btn-1" onClick={()=>handleSelectSport('table_tanis')} style={btn1stylett}>{xT}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle33}>{val1T}</button> */}
            {/* <button type="button" class="btn btn btn-sm slected-btn btn-1" onClick={handle2} style={btn2style}>{y}</button>
                            <button type="button" class="btn btn-outline-secondary btn-sm cancel-btn btn-2" onClick={handle4}>{val2}</button> */}
            {/* </div>
              </>
            ) : null} */}

            <span className=" mt-3" style={{ fontSize: "15px", color: "#fff" }}>
              Once you have enrolled in your preferred sport(s), your team
              selection will be confirmed for the tournament.
            </span>
          </div>
          {/* team selection */}

          <div className="submitbtn">
            {DashboardRedirect ? (
              <button
                type="button"
                class="btn text-white font-weight-bold sport_selection_submit_btn"
                onClick={() => navigate("/dashboard")}
              >
                Continue to dashboard
              </button>
            ) : (
              <button
                type="button"
                onClick={HandelSubmit}
                disabled={
                  sportSelection.batminton ||
                  sportSelection.tableTenis ||
                  sportSelection.bowling ||
                  sportSelection.twokRun ||
                  enrolled.badminton ||
                  enrolled.table_tennis ||
                  enrolled.bowling ||
                  enrolled.twok_run ||
                  EnableSubmit === true
                    ? false
                    : true
                }
                class="btn  text-white font-weight-bold sport_selection_submit_btn"
              >
                Next
              </button>
            )}

            {/* {
                            sportSelection.batminton || sportSelection.tableTenis || sportSelection.bowling || sportSelection.twokRun?  (
                                null

                            ) :<button type="button" onClick={LogoutPlayer} class="btn btn-danger text-white font-weight-bold mt-3">Logout</button>
                        } */}
          </div>
        </div>
      </FormContainer>
    </>
  );
};
export default SportSelection;
